import MyDriveWaitModal from "@modules/my-drive/components/MyDriveWaitModal";
import ResourceCopyContentSubpage from "@modules/my-drive/components/ResourceCopyContentSubpage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      readingTimer: null,
      readingTime: 0,
      status: "assigning",
      apiResponse: null,
      MAX_RESPONSE_TIME: 5,
      isRedirect: false,
      lessonUuid: null,
      resourceDomain: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isStudent"]),
  },
  methods: {
    initializeTimer(status) {
      this.resetTimer();
      this.setStatus(status);
      this.startTimer();
      this.setRedirect(false);
      this.$modal.removeAll();
    },
    setRedirect(value) {
      this.isRedirect = value;
    },
    setStatus(status) {
      this.status = status;
    },
    resetTimer() {
      clearInterval(this.readingTimer);
      this.readingTime = 0;
      this.apiResponse = null;
    },
    startTimer() {
      this.readingTimer = setInterval(() => {
        this.readingTime += 1;
        if (this.readingTime >= this.MAX_RESPONSE_TIME) {
          this.showMyDriveWaitModal();
        }
      }, 1000);
    },
    showMyDriveWaitModal(actionPrimary) {
      if (
        this.readingTime >= this.MAX_RESPONSE_TIME &&
        !this.isRedirect &&
        this.status === "duplicated"
      ) {
        clearInterval(this.readingTimer);
        this.$modal.removeAll();
      }
      if (this.readingTime >= this.MAX_RESPONSE_TIME && !this.isRedirect) {
        this.showResourceCopyModal(actionPrimary);
      }
    },
    showResourceCopyModal(actionPrimary) {
      this.$modal.show(MyDriveWaitModal, {
        status: this.status,
        resource: this.itemType,
        lessonUuid: this.lessonUuid,
        resourceDomain: this.resourceDomain,
        isAdmin: this.isAdmin,
        actionSecondary: () => {
          this.$contentSubpage.removeAll(ResourceCopyContentSubpage);
          this.resetTimer();
          this.setRedirect(true);
          if (this.params.closeSubMenu && typeof this.params.closeSubMenu === "function") {
            this.params.closeSubMenu();
          }
          if (this.isStudent) {
            this.$router.push({
              name: "Dashboard",
            });
          }
        },
        actionPrimary: () => {
          this.resetTimer();
          this.$contentSubpage.removeAll(ResourceCopyContentSubpage);
          if (actionPrimary === "route") {
            this.$router.push({ name: "MyDriveHome" });
          } else {
            if (this.params.closeSubMenu && typeof this.params.closeSubMenu === "function") {
              this.params.closeSubMenu();
            }
            this.handleEditLesson();
          }
        },
      });
    },
  },
};
